<div class="table-menu-text flex flex-row items-center justify-center w-[100%]"
  [ngClass]="disabled ? 'disabled' : ''"
  (click)="itemClickEmitter()">
  <div class="table-menu-item w-[100%] {{menuItemClass}}">
    <app-all-icons [iconNameAndStyling]="iconNameAndStyling"></app-all-icons>
    <span>{{text}}</span>
  </div>
</div>
